<div class="sessionAuditSection">
    <app-session-audit-life-cycle *ngIf="isSessionAuditDetailsDataLoaded && !showLoader"
        [auditLifecycleInput]="sessionLifeCycleDetails">
    </app-session-audit-life-cycle>
    <p-fieldset legend="Audit Trail" *ngIf="isSessionAuditDetailsDataLoaded && !showLoader">
        <div class="grid">
            <div class="col-6">
                <app-session-audit-summary [auditSummaryDetails]="sessionAuditSummaryDetails"
                    (attributeDetailsOfTransaction)="showAuditItemDetails($event)"></app-session-audit-summary>
            </div>
            <div class="col-6 auditTrialDetailsSection">
                <app-audit-item-details
                    [auditTrialDetails]="auditAttributeDetailsOfTransaction"></app-audit-item-details>
            </div>
        </div>
    </p-fieldset>

</div>